import { $http } from './request';
import { useRequest } from 'alova/client';
import useAuthStore from '@/store/authStore';
import useUserStore from '@/store/userStore';
import { decryptImgFn } from '@/service/useUpload';
import { ElMessage, FormRules } from 'element-plus';
import { validEmail, validPhoneNumber } from '@/utils/validText';
export const useUserInfo = () => {
  const authStore = useAuthStore();
  const userStore = useUserStore();

  const {
    send: getUserInfo,
    loading,
    error,
    onError,
  } = useRequest<any, any>(
    () => {
      return $http.Post('/api/user/get', null, {
        // cacheFor: {
        //   mode: 'memory', // 缓存在内存中
        //   expire: 5000, // 毫秒
        // },
      });
    },
    {
      initialData: [],
      immediate: false,
      async middleware(context, next) {
        try {
          const data = await next();
          // authStore.routerPermissions = ['/employee-management', '/role-management'];
          authStore.funcPermissions = data.funcPermissions;
          authStore.modulePermissions = data.modulePermissions;
          authStore.routerPermissions = data.routerPermissions;
          authStore.mangerLevel = data.userInfo.mangerLevel;
          authStore.sign = data.userInfo.sign;
          userStore.userInfo = data.userInfo;
        } catch (error) {}
        return [];
      },
    }
  );
  return {
    getUserInfo,
    loading,
    onError,
    error,
  };
};

export const useEditUserInfo = () => {
  const condition = reactive<any>({
    username: '',
    phoneNumber: '',
    email: '',
    faceUrl: {
      key: '',
      url: '',
    },
    nickname: '',

    areaList: {
      picked: '+86',
      list: [
        {
          value: '+86',
        },
        {
          value: '+852',
        },
      ],
    },
  });

  const formRules = reactive<FormRules>({
    username: [{ required: true, message: $t('topBar_5'), trigger: 'blur' }],
    email: [
      {
        validator: () => validEmail(condition.email, true),
        message: $t('topBar_16'),
        trigger: 'blur',
      },
    ],
    phoneNumber: [
      {
        validator: () => validPhoneNumber(condition.phoneNumber, true),
        message: $t('topBar_17'),
        trigger: 'blur',
      },
    ],
  });

  const {
    send: updateUserInfo,
    loading,
    error,
    onError,
  } = useRequest<any, any>(
    () => {
      console.log('condition...', condition);
      return $http.Post('/api/user/update_user_info', {
        ...condition,
        areaCode: condition.areaList.picked,
      });
    },
    {
      immediate: false,
      initialData: [],
    }
  ).onSuccess(() => {
    ElMessage.success($t('topBar_18'));
  });

  return {
    condition,
    formRules,
    updateUserInfo,
    loading,
  };
};
